import Home from '@/components/page/Home/Index.vue';
import Vehicles from '@/components/page/Vehicles/Index.vue';
import Fleets from '@/components/page/Fleets/Index.vue';
import Bases from '@/components/page/Bases/Index.vue';
import Logs from '@/components/page/Logs/Index.vue';
import Kpi from '@/components/page/Kpi/Index.vue';
import Help from '@/components/page/Help/Index.vue';
import NotFound from '@/components/page/NotFound/Index.vue';

// Routes
const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Home
    },
    {
        path: '/vehicles',
        name: 'vehicles',
        component: Vehicles
    },
    {
        path: '/bases',
        name: 'bases',
        component: Bases
    },
    {
        path: '/fleets',
        name: 'fleets',
        component: Fleets
    },
    {
        path: '/kpi',
        name: 'kpi',
        component: Kpi
    },
    {
        path: '/logs',
        name: 'logs',
        component: Logs
    },
    {
        path: '/help',
        name: 'help',
        component: Help
    },
    {
        path: '*',
        name: '404',
        component: NotFound
    },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js